export const MARKDOWN_LANGUAGE_LABELS: Record<string, string> = {
  ts: 'TypeScript',
  typescript: 'TypeScript',
  tsx: 'TypeScript (JSX)',
  js: 'JavaScript',
  javascript: 'JavaScript',
  jsx: 'JavaScript (JSX)',
  json: 'JSON',
  css: 'CSS',
  scss: 'SCSS',
  html: 'HTML',
  yaml: 'YAML',
  yml: 'YAML',
  sql: 'SQL',
  py: 'Python',
  python: 'Python',
}
